import { Flex } from 'antd';
import styled from 'styled-components';
import { ImageContainer } from '../../../styles/commonStyles';

export const Header = styled(Flex).attrs({ align: 'center' })`
  background-color: #fff;
  padding: 20px;
  border-bottom: 1px solid #dededf;
`;

export const BackButton = styled.div`
  margin-right: 20px;
  height: 32px;
  display: flex;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: ${(props) => props.theme.antd?.colorPrimary};
  }
`;

export const Content = styled(Flex).attrs({ gap: 20 })`
  height: 100%;
  padding-left: 24px;
  padding-top: 8px;
  margin: 0 auto;
  max-width: 1440px;
  width: 100%;
`;

export const IssueContainer = styled(Flex).attrs({ flex: 1, vertical: true })`
  padding: 8px 60px;
  height: 100%;
  overflow-y: auto;
`;

export const SectionTitle = styled.h4`
  margin: 0;
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
  color: #334423;
  span {
    margin-left: 8px;
    color: ${(props) => props.theme.antd?.colorPrimary};
  }
`;

export const Tag = styled(Flex).attrs({ gap: 8, align: 'center' })`
  padding: 0 8px;
  border-radius: 2px;
  border: 1px solid #b0d086;
  color: ${(props) => props.theme.antd?.colorPrimary};
  font-size: 12px;
  line-height: 20px;
`;

export const DiagnoseTitle = styled.p`
  margin: 0 0 12px;
  color: ${(props) => props.theme.antd.colorPrimary};
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
  text-align: center;
`;

export const IssueCard = styled(Flex).attrs({ align: 'center' })`
  position: relative;
  background-color: #fff;
  padding: 8px;
  button {
    width: 68px;
  }
  .arrow-right,
  .arrow-left {
    position: absolute;
    top: 50%;
    border: 0 none;
    svg {
      transition: all ease 0.2s;
    }
    &:hover {
      svg {
        transform: scale(120%);
      }
    }
  }
  .arrow-left {
    left: -50px;
    transform: translateY(-50%) rotate(180deg);
  }
  .arrow-right {
    right: -50px;
    transform: translateY(-50%);
  }
`;

export const IssueCardImageContainer = styled(ImageContainer)`
  width: 80px;
  height: 60px;
`;

export const SelectedIssueContainer = styled(Flex).attrs({
  vertical: true,
  gap: 12,
})`
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
`;

export const IssueName = styled.p`
  font-weight: 500;
  margin: 0;
  line-height: 22px;
  font-size: 12px;
`;

export const IssueDescription = styled.p`
  margin: 0;
  line-height: 22px;
  font-size: 12px;
  color: #85878b;
`;

export const IdentifyingIssue = styled(Flex)``;
export const IdentifiedIssue = styled(Flex)``;

export const Percentage = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  border-radius: 100%;
  width: 24px;
  height: 24px;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  color: #fff;
  background-color: #e6e8f9;
  color: #6a63c2;
  &.level2 {
    background-color: #d3d8f2;
    color: #6a63c2;
  }
  &.level3 {
    background-color: #8181d3;
    color: #fff;
  }
  &.level4 {
    background-color: #6a63c2;
    color: #fff;
  }
  &.level5 {
    background-color: #4d488b;
    color: #fff;
  }
`;
